var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"home",attrs:{"id":"promo"}},[_c('PromoSection'),_c('Mechanics',{attrs:{"id":"mechanics"}}),_c('PrizesSection',{attrs:{"id":"prizes"}}),_c('WinnersSection',{attrs:{"id":"winners"}}),_c('FaqSection',{attrs:{"id":"faq"},on:{"getThanksText":_vm.getThanksText,"getErrorText":_vm.getErrorText}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }